import currentLifeEvent from '../data/dashboard/currentLifeEvent.json';
import enrollment from '../data/dashboard/enrollment.json';
import fingertipsLinks from '../data/dashboard/fingertipLinks.json';
import healthSavings from '../data/dashboard/healthSavings.json';
import savingsSnapshot from '../data/dashboard/savingsSnapshot.json';
import totalRewards from '../data/dashboard/totalRewards.json';
import otherCompanyBenefits from '../data/dashboard/otherCompanyBenefits.json';
import { getActiveHealthBenefits, getCoveredFamilyMembers } from './enrollment';

export const getEnrollment = () => {
  return enrollment['data'];
};

export const getCurrentLifeEvent = () => {
  return currentLifeEvent['data'];
};

export const getFingertipsLinks = (persona: string): any[] => {
  const data: any = fingertipsLinks['data'];
  return data[persona] || [];
};

export const getOtherCompanyBenefits = (): any[] => {
  return otherCompanyBenefits['data'] || [];
};

export const getHealthSavings = () => {
  return healthSavings['data'];
};

export const getTotalRewards = () => {
  return totalRewards['data'];
};

export const getHealthSnapshot = () => {
  return getActiveHealthBenefits().filter(
    (healthBenefits) =>
      healthBenefits.type === 'medical' ||
      healthBenefits.type === 'dental' ||
      healthBenefits.type === 'vision'
  );
};

export const getHealthSnapshotCoveredMembersHw = () => {
  return getCoveredFamilyMembers().slice(0, 3);
};

export const getHealthSnapshotCoveredMembersHwDb = () => {
  return getCoveredFamilyMembers().slice(3, 6);
};

export const getSavingsSnapshot = () => {
  return savingsSnapshot['data'];
};
